import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent {


  constructor(
    public dialog: MatDialog,private dialogRef: MatDialogRef<AppComponent>,@Inject(MAT_DIALOG_DATA) public data: any

    
  ) { 
    
  }

  submit() {
    this.dialogRef.close(true); 
  }

  cancelDialog() {
    this.dialogRef.close(false); 
  }
}
